import http from "../http";

export async function getFiles(config) {
  const response = await http.get("/portfolio/upload-boarding-file", config);
  return response.data;
}

export async function uploadFile(data) {
  const response = await http.post("/portfolio/upload-boarding-file", data, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });

  return response.data;
}

export async function remove(id) {
  const response = await http.delete(`/portfolio/boarding/${id}`);
  return response.data;
}

export async function addPortfolioName(data) {
  const response = await http.post("/portfolio", data);

  return response.data;
}

export async function removePortfolioName(id) {
  const response = await http.delete(`/portfolio/${id}`);
  return response.data;
}
